<div class="rx-app-flex rx-app-flex-container-column rx-app-flex-container-column--align-stretch">
	<div class="rx-app-flex mr-3">
		<span class="license-title">{{ 'DoctorSection.License' | translate}}:</span>
	</div>
	<div class="rx-app-flex--full">
		<span class="license">{{license}}</span>
	</div>
</div>
